/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const CHECKBOX_THEME = {
  defaultProps: {
    colorScheme: "brandPrimary",
  },
};
